import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MapInstructions from './instructions/mapInstructions';
import ChartInstructions from './instructions/ChartInstructions';
import PorInstructions from './instructions/porInstructions';

class Instructions extends Component {
  state = {
    page: null
  }

  componentDidMount = () => {
    const path = this.props.location.pathname.split('/')[1];
    switch(path){
      case '': return this.setState({page: null});
      case 'map': return this.setState({page: 'Map'});
      case 'charts': return this.setState({page: 'Charts'});
      case 'por': return this.setState({page: 'Period of Record'});
      default: return this.setState({page: null})
    }
  }

  render(){
    if(!this.state.page ){
      return <div className='instuction-panel'>
        <p>Pick a page to view</p>
        <ul>
          <li>Map</li>
          <li>Charts</li>
          <li>Period of Record</li>
        </ul>
      </div>
    }
    return (
      <div className='instruction-panel'>
        <h2>{this.state.page}</h2>
        {
          this.state.page === 'Map' && <MapInstructions />
        }
        {
          this.state.page === 'Charts' && <ChartInstructions />
        }
        {
          this.state.page === 'Period of Record' && <PorInstructions />
        }
        <div className='contact'>If you require further assistance, please contact Graham Long: <a href="mailto:glong@compassrm.com"> glong@compassrm.com</a></div>
      </div>
    )
  }
}

export default withRouter(Instructions)


// WEBPACK FOOTER //
// ./src/components/Instructions.js